export default {
  labels: {
    card: 'Creditcard',
    bank_account: 'Bankrekening',
  },
  alerts: {
    payments_not_configured:
      'Betalingen zijn nog niet geconfigureerd. Neem contact op met uw provider om betalingen in te schakelen en kom daarna terug naar deze stap.',
  },
  buttons: {
    change_payment_method: 'Betaalmethode wijzigen',
    save_payment_info: 'Betalingsgegevens opslaan',
  },
  toasts: {
    failed_to_init_payment_setup: 'Betalingsinstellingen konden niet worden gestart, herlaad de pagina',
    successfully_saved_payment_method: 'Betalingsgegevens zijn opgeslagen',
  },
};
